export default "__VITE_ASSET__oq0iGHN4__"